import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;

export const selectorAvailablePlanEnrollments = (
  planEnrollments: IPlanEnrollment[],
  now: Date
): IPlanEnrollment[] => {
  return planEnrollments.filter(
    planEnrollment => !planEnrollment.endDate || planEnrollment.endDate > now
  );
};
